import { primary } from '@/styles/Default/additives';
import { ThemeOptions } from '@mui/material/styles';

const paletteColors = {
	white: '#fffffe',
	ghostWhite: '#f9fbfb',
	azure: '#3da9fc',
	lightBlue: '#d8eefe',
	paleBlue: '#90b4ce',
	midnightBlue: '#094067',
	gray: '#5f6c7b',
	red: '#ef4565',
	black:'#000000',
	green:'#53aa28',
	darkgreen:'#3b7b1b',
};

export const palette: ThemeOptions = {
	palette: {
		'navbar':{
			primary:'#ffdc00',
			secondary:'#fffad9'
	  	},
		primary: {
			main: paletteColors.black,
			dark: paletteColors.black,
			light: paletteColors.white,
			contrastText: paletteColors.white,		
		},
		secondary: {
			main: paletteColors.black,
			light: paletteColors.white,
			dark: paletteColors.black,
			contrastText: paletteColors.white,
		},
		text: {
			main: paletteColors.black,
			primary: paletteColors.black,
			secondary: paletteColors.black,
			disabled: paletteColors.black,
			highlight: paletteColors.black,
			alert: paletteColors.black,
			expandedMenu: paletteColors.white,
			offerPrice:'#e50241'
		},
		base: {
			main: paletteColors.gray,
			contrastText: paletteColors.white,
		},
		action: {
			hover: '#D3D3D3',
			disabled: paletteColors.gray,
			disabledBackground: paletteColors.ghostWhite,
		},
		background: {
			main: paletteColors.white,
			default: paletteColors.white,
			paper: paletteColors.white,
			transparency: 'cc',
			contrastText: paletteColors.black,
		},
		divider: paletteColors.black,
		border: {
			dark: paletteColors.black,
			alert: paletteColors.red,
			footer: paletteColors.black,
		},
		textField: {
			border: paletteColors.black,
			borderHovered: paletteColors.gray,
			background: paletteColors.white,
			disabledBackground: paletteColors.white,
		},
		button: {
			primary: paletteColors.white,
			primaryBackground: paletteColors.black,
			primaryHover: paletteColors.black,
			primaryCheckout: paletteColors.green,
			primaryCheckoutHover: paletteColors.darkgreen,
			secondary: paletteColors.black,
			secondaryBackground:paletteColors.white,
			secondaryHover: paletteColors.black,
			contrastText: paletteColors.white,
			disabled: paletteColors.gray,
			disabledText: paletteColors.white,
			borderColor:paletteColors.black,
		},
		info: {
			main: '#000000',
			light: '#99c2e1',
			dark: '#01579b',
			contrastText: '#ffffff',
		},
		'gratis':{
			primary: paletteColors.darkgreen
		},
		'ariaDescLabel':{
			primary: '#545454'
		},
		'placeholder':{
			primary: paletteColors.black
		}
	},
} as ThemeOptions;